@if (!isNative) {
  <div [ngClass]="{'h-100': isFullScreen()}">
    @if (!isFullScreen()) {
      <app-header [isSidenavShowing]="isSidenavShowing" (onMenuShow)="setSidenavShow($event)"
        (onFixedHeader)="onFixedHeader($event)">
      </app-header>
    }
    <mat-sidenav-container [style]="isSidenavShowing && !isFullScreen() ? { maxHeight: 'calc(100vh - $header-large-height)' } : null" [ngClass]="{'h-100': isFullScreen()}">
      @if (!isFullScreen()) {
        <mat-sidenav id="primary-sidenav" mode="over" position="end" [(opened)]="isSidenavShowing" class="d-lg-none"
          style="width: 100%" #sidenav>
          <app-sidenav [isShowing]="isSidenavShowing" [sidenavRef]="sidenav"></app-sidenav>
        </mat-sidenav>
      }
      <mat-sidenav-content [ngClass]="{'h-100': isFullScreen(), 'fixed-header': isFixedHeader && !isFullScreen()}" id="mat-sidenav-content" scrollTracker>
        <main>
          <div class="component-container">
            <assurant-loader></assurant-loader>
            <pgh-loader-progress></pgh-loader-progress>
            <router-outlet></router-outlet>
          </div>
        </main>
        <div id="miaw-chat-messaging" class="miawChatBadge_hidden"></div>
        @if (!isFullScreen()) {
          <app-footer [isSidenavShowing]="isSidenavShowing"></app-footer>
        }
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
}
@if (isNative) {
  <div>
    <main>
      <router-outlet></router-outlet>
    </main>
  </div>
}
